export const contactsOrderBy = {
  FirstName: 'firstName',
  LastName: 'lastName',
  Email: 'emailAddress',
  PhoneNumber: 'phoneNumber',
  Active: 'active'
};
